import axios from 'axios';

// Interceptor-free: the default instance rewrites /api into the org path and signs the user out on a 401.
const publicAxios = axios.create();

export type CompanySearchRow = {
  orgNumber: string;
  name: string;
  street: string | null;
  postalCode: string | null;
  city: string | null;
};

export type CompanySearchOutcome =
  | { kind: 'found'; rows: CompanySearchRow[]; truncated: boolean }
  | { kind: 'busy' }
  | { kind: 'off' }
  | { kind: 'unavailable' };

class ServiceCompanySearch {
  async suggest(query: string): Promise<CompanySearchOutcome> {
    try {
      const { data } = await publicAxios.post('/api/company-search/suggest', { q: query });
      return { kind: 'found', rows: data.rows, truncated: data.truncated };
    } catch (error) {
      const status = axios.isAxiosError(error) ? error.response?.status : undefined;
      if (status === 429) return { kind: 'busy' };
      if (status === 503) return { kind: 'off' };
      return { kind: 'unavailable' };
    }
  }
}

export default new ServiceCompanySearch();
